<div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="file-text" nzTheme="outline" class="p-r-5"></i>{{title}}</h3>
    <!-- <button nz-button nzType="text" (click)="downloadToPDF()" nz-tooltip nzTooltipTitle="Download to PDF">
        <span nz-icon nzType="download" nzTheme="outline"></span>
    </button> -->
</div>
<div class="markDownSec">
    <ng-container *ngIf="isFile; else showWithData">
        <markdown [src]="fileSrc"></markdown>
    </ng-container>
    <ng-template #showWithData>
        <markdown [data]="textContent"></markdown>
    </ng-template>
</div>